module.exports = __webpack_public_path__ + "static/img/iphone_room_left.501634b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room_left.png
// module id = Ru7r
// module chunks = 0